var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.07 28.246v1.157c0 .54.438.975.977.975.54 0 .977-.435.977-.975V28.24a1.984 1.984 0 0 0 1.007-1.717 1.987 1.987 0 0 0-3.905-.508 1.98 1.98 0 0 0 .944 2.231m10.051 4.232c0 .234-.054 2.321-1.951 2.4-2.832.11-14.087.012-14.227.006-.174 0-1.699-.085-1.99-2.809V20.776h18.168v11.702ZM22.008 8.95c5.485 0 5.8 4.545 5.817 5.032v4.844H16.192v-4.577c.005-.221.194-5.299 5.816-5.299Zm10.09 9.876h-2.32v-4.87C29.716 11.551 28.013 7 22.008 7s-7.708 4.707-7.77 7.223v4.603h-2.261A.975.975 0 0 0 11 19.8v12.326c0 .033.002.065.005.098.377 3.751 2.783 4.68 3.945 4.61a917.6 917.6 0 0 0 8.843.045c2.291 0 4.409-.013 5.456-.052 3.025-.124 3.826-2.9 3.826-4.35V19.801a.975.975 0 0 0-.977-.975Z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.433f58c5d35a99babb877889535f248d.svg";
export { ForwardRef as ReactComponent };